/**
 * Settings service — the admin-configurable platform settings collection.
 *
 * Currently a single doc, `settings/scheduling` (the rescheduling &
 * cancellation policy). Reads are open to any signed-in user (the UI shows
 * quota meters from it); writes are admin-only (enforced by rules). The
 * scheduling callables re-read the doc inside their transactions, so a saved
 * change takes effect immediately and atomically.
 *
 * Field defaults + shape: src/features/scheduling/policy.js
 * (DEFAULT_SCHEDULING_POLICY).
 */
import firestoreService from './firestore.service';

const COLLECTION = 'settings';
const SCHEDULING_DOC = 'scheduling';

export const settingsService = {
  /** Realtime subscription to the scheduling policy doc (null until created). */
  subscribeScheduling(onData, onError) {
    return firestoreService.subscribeDocument(COLLECTION, SCHEDULING_DOC, onData, onError);
  },

  getScheduling() {
    return firestoreService.getDocument(COLLECTION, SCHEDULING_DOC);
  },

  /** Admin: merge-update the scheduling policy. */
  updateScheduling(patch) {
    return firestoreService.setDocument(COLLECTION, SCHEDULING_DOC, patch);
  },
};

export default settingsService;
